import Cookies from "js-cookie";

import {
  // getAllLoanRequestsOfEmpByAdminQueryOptions,
  getAllLoanRequestsQueryOptions,
} from "@/config/queries/query-options";
import { CreateEmpLoan } from "./_components/create-emp-loan";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { Spinner } from "@/components/ui/spinner/spinner";
import { DataTable } from "./_components/loan-table/data-table";
import { columns } from "./_components/loan-table/columns";

import { useStatusFilter } from "./hooks/use-status-filter";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";
import { Button } from "@/components/ui/button/button";
import { DoubleArrowDownIcon } from "@radix-ui/react-icons";
import { Separator } from "@/components/ui/separator/separator";
import {
  RadioGroup,
  RadioGroupItem,
} from "@/components/ui/radio-group/radio-group";
import { Label } from "@/components/ui/label/label";
import { TakeActionOnLoanRequesetModal } from "./_components/take-action-modal/take-action-modal";
import { DeleteLoanModal } from "./_components/delete-load-modal/delete-loan-modal";

const OtherLoansOfEmployee = () => {
  const key = Cookies.get("key") as string;
  const { filter, setFilter } = useStatusFilter();

  // const { data, isPending, isFetching } = useQuery(
  //   getAllLoanRequestsOfEmpByAdminQueryOptions(key)
  // );

  const { data, isPending, isFetching } = useQuery(
    getAllLoanRequestsQueryOptions(key, filter)
  );

  const loanRequestsData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.loans === undefined) {
      return [];
    }

    const result = data?.loans?.map((la) => {
      return {
        id: la?._id,
        totalAmountRequested: la?.totalAmountRequested,
        status: la?.status,
        employeeName: la?.employeeId?.name,
        employeeEmail: la?.employeeId?.email,
        createdAt: la?.createdAtIST,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [isPending, isFetching, data]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Employee Loans</h3>

        <div className="flex items-center gap-5">
          <CreateEmpLoan />

          <Popover>
            <PopoverTrigger>
              <Button
                className="mr-3 flex items-center gap-2"
                size="sm"
                variant="outline"
              >
                <DoubleArrowDownIcon className="w-4 h-4" />
                Filter
                {filter && (
                  <>
                    <Separator orientation="vertical" />
                    {filter} ({loanRequestsData?.length})
                  </>
                )}
              </Button>
            </PopoverTrigger>
            <PopoverContent>
              <RadioGroup
                value={filter}
                onValueChange={(value: "Pending" | "Approved" | "Rejected") => {
                  setFilter(value);
                }}
              >
                <div className="flex items-center space-x-2 cursor-pointer w-fit">
                  <RadioGroupItem value="Pending" id="pending" />
                  <Label htmlFor="pending">Pending</Label>
                </div>
                <div className="flex items-center space-x-2 cursor-pointer w-fit">
                  <RadioGroupItem value="Approved" id="approved" />
                  <Label htmlFor="approved">Approved</Label>
                </div>
                <div className="flex items-center space-x-2 cursor-pointer w-fit">
                  <RadioGroupItem value="Rejected" id="rejected" />
                  <Label htmlFor="rejected">Rejected</Label>
                </div>
              </RadioGroup>
            </PopoverContent>
          </Popover>
        </div>
      </div>

      {isPending ? (
        <div className="h-20 mt-10 flex items-center justify-center">
          <Spinner size="small">
            <p>Searching for Loan...</p>
          </Spinner>
        </div>
      ) : data?.loans?.length ? (
        <div className="mt-5">
          <DataTable data={loanRequestsData} columns={columns} />
        </div>
      ) : (
        <div className="border h-20 flex items-center justify-center mt-5">
          No Loan
        </div>
      )}

      <TakeActionOnLoanRequesetModal />
      <DeleteLoanModal />
    </div>
  );
};

export default OtherLoansOfEmployee;
